import React from "react";
import { COLORS, FONT_BODY, NAV_CLEARANCE } from "../theme.js";
import { LogoMark } from "./ui.jsx";

/* Home is the middle entry, not the first, because it renders as the mark
   rather than an emoji — and a logo button reads as the anchor of the row only
   when the row is symmetrical around it. Two tabs sit either side. */
const NAV_TABS = [
  { key: "passport", label: "Passport", icon: "📘" },
  { key: "flight", label: "Flight", icon: "✈️" },
  { key: "home", label: "Home", home: true },
  { key: "hub", label: "Hub", icon: "🛡️" },
  { key: "profile", label: "Profile", icon: "👤" },
];

export default function BottomNav({ active, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "12px 6px",
        paddingBottom: "calc(12px + env(safe-area-inset-bottom))",
        // Shared with the toast, so it can position itself above the nav
        // without a second copy of this number to keep in step.
        minHeight: NAV_CLEARANCE,
        borderTop: `1px solid ${COLORS.line}`,
        background: COLORS.black,
        flex: "none",
      }}
    >
      {NAV_TABS.map((t) => {
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            aria-label={t.label}
            aria-current={isActive ? "page" : undefined}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
              color: isActive ? COLORS.goldBright : COLORS.creamFaint,
            }}
          >
            {t.home ? (
              /* The mark is a fixed gold; dimming the whole button would just
                 make it look broken, so inactive is carried by the ring. */
              <span
                style={{
                  width: 34,
                  height: 34,
                  marginTop: -3,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: `1px solid ${isActive ? COLORS.gold : COLORS.line}`,
                  background: isActive ? "rgba(201,162,39,0.16)" : "transparent",
                  opacity: isActive ? 1 : 0.62,
                }}
              >
                <LogoMark size={19} />
              </span>
            ) : (
              <span style={{ fontSize: 18 }}>{t.icon}</span>
            )}
            <span style={{ fontSize: 10, fontFamily: FONT_BODY, fontWeight: isActive ? 600 : 400 }}>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
